module.exports = __webpack_public_path__ + "img/hint-kyc.f1250fd1.svg";